import { baseApi } from "./baseApi";

const SHIPMENT_BASE_URL = "/shipments";

export const shipmentApi = baseApi.injectEndpoints({
  tagTypes: ["Shipment", "ShipmentFD", "ShipmentRoute", "ShipmentPrice"],
  endpoints: (builder) => ({
    // Add a new shipment
    addShipment: builder.mutation({
      query: (payLoad) => ({
        url: SHIPMENT_BASE_URL,
        method: "POST",
        body: payLoad,
      }),
      invalidatesTags: (_result, _error, { _id }) => [
        { type: "Shipment", id: _id },
        { type: "Shipment", id: "LIST" },
      ],
    }),
    addShipmentAndCollect: builder.mutation({
      query: (payLoad) => ({
        url: `${SHIPMENT_BASE_URL}/addShipmentAndCollect`,
        method: "POST",
        body: payLoad,
      }),
      invalidatesTags: (_result, _error, { _id }) => [
        { type: "Shipment", id: _id },
        { type: "Shipment", id: "LIST" },
      ],
    }),
    assignBulkRoutes: builder.mutation({
      query: (payLoad) => ({
        url: `${SHIPMENT_BASE_URL}/bulk-assign`,
        method: "POST",
        body: payLoad,
      }),
      invalidatesTags: (_result, _error, { _id }) => [
        { type: "Shipment", id: _id },
        { type: "Shipment", id: "LIST" },
      ],
    }),
    getDDLBranchesWithPendingShipments: builder.query({
      query: (params) => ({
        url: `${SHIPMENT_BASE_URL}/ddlBranchesWithPending`,
        params,
      }),
      providesTags: [{ type: "Shipment", id: "DDL_BRANCHES" }],
    }),
    assignBulkRoutesWarehouse: builder.mutation({
      query: (payLoad) => ({
        url: `${SHIPMENT_BASE_URL}/bulk-assign-warehouse`,
        method: "POST",
        body: payLoad,
      }),
      invalidatesTags: (_result, _error, { _id }) => [
        { type: "Shipment", id: _id },
        { type: "Shipment", id: "LIST" },
      ],
    }),
    vendorShipmentAdd: builder.mutation({
      query: (payLoad) => ({
        url: `${SHIPMENT_BASE_URL}/vendorShipmentAdd`,
        method: "POST",
        body: payLoad,
      }),
      invalidatesTags: (_result, _error, { _id }) => [
        { type: "Shipment", id: _id },
        { type: "Shipment", id: "LIST" },
      ],
    }),
    // Create multiple shipments in bulk
    createBulkShipments: builder.mutation({
      query: (payLoad) => ({
        url: `${SHIPMENT_BASE_URL}/bulk-import`,
        method: "POST",
        body: payLoad,
      }),
      invalidatesTags: (_result, _error, { _id }) => [
        { type: "Shipment", id: _id },
        { type: "Shipment", id: "LIST" },
      ],
    }),
    // List shipments with pagination and filters
    listShipment: builder.query({
      query: (params) => ({
        url: SHIPMENT_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result.data.map(({ _id }) => ({
              type: "Shipment",
              id: _id,
            })),
            { type: "Shipment", id: "LIST" },
          ]
          : [{ type: "Shipment", id: "LIST" }],
    }),
    listShipmentStale: builder.query({
      query: (params) => ({
        url: `${SHIPMENT_BASE_URL}/StaleShipmentList`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result.data.map(({ _id }) => ({
              type: "Shipment",
              id: _id,
            })),
            { type: "Shipment", id: "LIST" },
          ]
          : [{ type: "Shipment", id: "LIST" }],
    }),
    listShipmentStaleProvinceMode: builder.query({
      query: (params) => ({
        url: `${SHIPMENT_BASE_URL}/StaleShipmentProvinceMode`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result.data.map(({ _id }) => ({
              type: "Shipment",
              id: _id,
            })),
            { type: "Shipment", id: "PROVINCE_MODE" },
          ]
          : [{ type: "Shipment", id: "PROVINCE_MODE" }],
    }),
    getPendingShipmentsByBranch: builder.query({
      query: (params) => ({
        url: `${SHIPMENT_BASE_URL}/getPendingShipmentsByBranch`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result.data.map(({ _id }) => ({
              type: "Shipment",
              id: _id,
            })),
            { type: "Shipment", id: "LIST" },
          ]
          : [{ type: "Shipment", id: "LIST" }],
    }),
    listShipmentForBulkCancels: builder.query({
      query: (params) => ({
        url: `${SHIPMENT_BASE_URL}/ShipmentListForBulkCancels`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result.data.map(({ _id }) => ({
              type: "Shipment",
              id: _id,
            })),
            { type: "Shipment", id: "LIST" },
          ]
          : [{ type: "Shipment", id: "LIST" }],
    }),
    // Get shipment dropdown list
    getDDLShipmentList: builder.query({
      query: (params) => ({ url: `${SHIPMENT_BASE_URL}/ddl`, params }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({
              type: "Shipment",
              id: _id,
            })),
            { type: "Shipment", id: "DDL" },
          ]
          : [{ type: "Shipment", id: "DDL" }],
    }),

    getDDLShipmentPendingList: builder.query({
      query: (params) => ({ url: `${SHIPMENT_BASE_URL}/ddlPending`, params }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({
              type: "Shipment",
              id: _id,
            })),
            { type: "Shipment", id: "DDL" },
          ]
          : [{ type: "Shipment", id: "DDL" }],
    }),
    // Get shipment dropdown list for COC
    getDDLShipmentListForCOC: builder.query({
      query: (params) => ({ url: `${SHIPMENT_BASE_URL}/ddl/COC`, params }),
      transformResponse: (response) => ({
        data: Array.isArray(response?.data) ? response.data : [],
        priceItems: Array.isArray(response?.priceItems)
          ? response.priceItems
          : [],
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result.data.map(({ _id }) => ({
              type: "Shipment",
              id: _id,
            })),
            { type: "Shipment", id: "DDL" },
          ]
          : [{ type: "Shipment", id: "DDL" }],
    }),

    // Get shipment dropdown list for COD
    getDDLShipmentListForCOD: builder.query({
      query: (params) => ({ url: `${SHIPMENT_BASE_URL}/ddl/COD`, params }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({
              type: "Shipment",
              id: _id,
            })),
            { type: "Shipment", id: "DDL" },
          ]
          : [{ type: "Shipment", id: "DDL" }],
    }),

    getDDLShipmentListForPrepayment: builder.query({
      query: (params) => ({
        url: `${SHIPMENT_BASE_URL}/ddl/prepayment`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({
              type: "Shipment",
              id: _id,
            })),
            { type: "Shipment", id: "DDL" },
          ]
          : [{ type: "Shipment", id: "DDL" }],
    }),

    // Get details of a specific shipment
    getShipmentDetail: builder.query({
      query: (shipmentId) => `${SHIPMENT_BASE_URL}/${shipmentId}`,
      providesTags: (result, error, shipmentId) => [
        { type: "Shipment", id: shipmentId },
      ],
    }),
    // Update an existing shipment
    updateShipment: builder.mutation({
      query: ({ _id, ...body }) => ({
        url: `${SHIPMENT_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { _id }) => [
        { type: "Shipment", id: _id },
        { type: "Shipment", id: "LIST" },
        { type: "Shipment", id: "DDL" },
      ],
    }),
    updateShipmentForVendorSide: builder.mutation({
      query: ({ _id, ...body }) => ({
        url: `${SHIPMENT_BASE_URL}/${_id}/vendorPortal`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { _id }) => [
        { type: "Shipment", id: _id },
        { type: "Shipment", id: "LIST" },
        { type: "Shipment", id: "DDL" },
      ],
    }),
    // Add comments to a shipment
    addShipmentComments: builder.mutation({
      query: (payload) => {
        const { shipmentId, ...body } = payload;
        return {
          url: `${SHIPMENT_BASE_URL}/${shipmentId}/comments`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: (_result, _error, { shipmentId }) => [
        { type: "Shipment", id: shipmentId },
        { type: "Shipment", id: "LIST" },
      ],
    }),
    // Gets Shipment Change Logs
    getShipmentLogs: builder.query({
      query: (shipmentId) => `${SHIPMENT_BASE_URL}/${shipmentId}/changeLog`,
      providesTags: (result, error, shipmentId) => [
        { type: "Shipment", id: shipmentId },
      ],
    }),
    // Update a shipment comment
    updateShipmentComment: builder.mutation({
      query: ({ shipmentId, commentId, ...body }) => ({
        url: `${SHIPMENT_BASE_URL}/${shipmentId}/comments/${commentId}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { shipmentId }) => [
        { type: "Shipment", id: shipmentId },
        { type: "Shipment", id: "LIST" },
      ],
    }),
    // List comments for a shipment
    listShipmentComments: builder.query({
      query: ({ shipmentId, page, limit }) => ({
        url: `${SHIPMENT_BASE_URL}/${shipmentId}/comments`,
        params: { page, limit },
      }),
      providesTags: (_result, _error, { shipmentId }) => [
        { type: "Shipment", id: shipmentId },
        { type: "Shipment", id: "LIST" },
      ],
    }),
    // Add a reply to a shipment comment
    addShipmentReply: builder.mutation({
      query: ({ shipmentId, commentId, replyText, user }) => ({
        url: `${SHIPMENT_BASE_URL}/${shipmentId}/comments/${commentId}/replies`,
        method: "POST",
        body: { replyText, user },
      }),
      invalidatesTags: (_result, _error, { shipmentId }) => [
        { type: "Shipment", id: shipmentId },
        { type: "Shipment", id: "LIST" },
      ],
    }),
    // Update a reply to a shipment comment
    updateShipmentReply: builder.mutation({
      query: ({ shipmentId, commentId, replyId, ...body }) => ({
        url: `${SHIPMENT_BASE_URL}/${shipmentId}/comments/${commentId}/replies/${replyId}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { shipmentId }) => [
        { type: "Shipment", id: shipmentId },
        { type: "Shipment", id: "LIST" },
      ],
    }),
    // Add a document to a shipment
    addShipmentDocumentByDShipmentId: builder.mutation({
      query: ({ shipmentId, ...body }) => ({
        url: `${SHIPMENT_BASE_URL}/${shipmentId}/documents`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_result, _error, { shipmentId }) => [
        { type: "Shipment", id: shipmentId },
        { type: "Shipment", id: "LIST" },
      ],
    }),
    // List documents for a shipment
    listShipmentDocumentByShipmentId: builder.query({
      query: ({ shipmentId, page, limit, ...params }) => ({
        url: `${SHIPMENT_BASE_URL}/${shipmentId}/documents`,
        params,
      }),
      providesTags: (_result, _error, { shipmentId }) => [
        { type: "Shipment", id: shipmentId },
        { type: "Shipment", id: "LIST" },
      ],
    }),
    // Update a shipment document
    updateShipmentDocumentByShipmentId: builder.mutation({
      query: ({ shipmentId, documentId, type, attachments }) => ({
        url: `${SHIPMENT_BASE_URL}/${shipmentId}/documents/${documentId}`,
        method: "PUT",
        body: { type, attachments },
      }),
      invalidatesTags: (_result, _error, { shipmentId }) => [
        { type: "Shipment", id: shipmentId },
      ],
    }),
    // Add a route to a shipment
    addShipmentRoute: builder.mutation({
      query: ({ shipmentId, ...body }) => {
        return {
          url: `${SHIPMENT_BASE_URL}/${shipmentId}/routes`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: (_result, _error, { shipmentId }) => [
        { type: "Shipment", id: shipmentId },
        { type: "ShipmentRoute", id: "LIST" },
      ],
    }),
    // List routes for a shipment
    listShipmentRoutes: builder.query({
      query: ({ shipmentId, page, limit, ...params }) => ({
        url: `${SHIPMENT_BASE_URL}/${shipmentId}/routes`,
        params: { page, limit, ...params },
      }),
      providesTags: (_result, _error, { shipmentId }) => [
        { type: "Shipment", id: shipmentId },
        { type: "ShipmentRoute", id: "LIST" },
      ],
    }),
    // Update a shipment route
    updateShipmentRoute: builder.mutation({
      query: ({ shipmentId, routeId, ...body }) => ({
        url: `${SHIPMENT_BASE_URL}/${shipmentId}/routes/${routeId}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { shipmentId }) => [
        { type: "Shipment", id: shipmentId },
        { type: "ShipmentRoute", id: "LIST" },
      ],
    }),
    // Add a price (or multiple prices) to a shipment in a single transaction.
    // Pass { shipmentId, items: [...] } for bulk mode, or flat fields for single mode.
    addShipmentPrice: builder.mutation({
      query: ({ shipmentId, ...body }) => ({
        url: `${SHIPMENT_BASE_URL}/${shipmentId}/prices`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_result, _error, { shipmentId }) => [
        { type: "Shipment", id: shipmentId },
        { type: "ShipmentPrice", id: "LIST" },
      ],
    }),
    generateShipmentEBill: builder.mutation({
      query: (shipmentId) => ({
        url: `${SHIPMENT_BASE_URL}/${shipmentId}/ebills`,
        method: "POST",
      }),
      invalidatesTags: (_result, _error, shipmentId) => [
        { type: "Shipment", id: shipmentId },
        { type: "ShipmentPrice", id: "LIST" },
      ],
    }),
    downloadShipmentEBill: builder.mutation({
      query: (shipmentId) => ({
        url: `${SHIPMENT_BASE_URL}/${shipmentId}/ebills/download`,
        method: "POST",
      }),
      invalidatesTags: (_result, _error, shipmentId) => [
        { type: "Shipment", id: shipmentId },
      ],
    }),
    // List prices for a shipment
    listShipmentPrices: builder.query({
      query: ({ shipmentId, page, limit, ...params }) => ({
        url: `${SHIPMENT_BASE_URL}/${shipmentId}/prices`,
        params: { page, limit, ...params },
      }),
      providesTags: (_result, _error, { shipmentId }) => [
        { type: "Shipment", id: shipmentId },
        { type: "ShipmentPrice", id: "LIST" },
      ],
    }),
    getShipmentPrice: builder.query({
      query: (priceId) => `/shipments/prices/${priceId}`,
      providesTags: (result, error, priceId) => [
        { type: "ShipmentPrice", id: priceId },
      ],
    }),
    // Update a shipment price
    updateShipmentPrice: builder.mutation({
      query: ({ shipmentId, priceId, ...body }) => ({
        url: `${SHIPMENT_BASE_URL}/${shipmentId}/prices/${priceId}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { shipmentId }) => [
        { type: "Shipment", id: shipmentId },
        { type: "ShipmentPrice", id: "LIST" },
      ],
    }),
    listPriceChangeLogs: builder.query({
      query: ({ priceId, params }) => ({
        url: `${SHIPMENT_BASE_URL}/prices/${priceId}/logs`,
        params,
      }),
      providesTags: (result, error, { priceId }) => [
        { type: "ShipmentPrice", id: priceId },
        { type: "ShipmentPrice", id: "LOGS" },
      ],
    }),
    getShipmentPriceEBills: builder.query({
      query: (priceId) => `${SHIPMENT_BASE_URL}/prices/${priceId}/ebills`,
      providesTags: (result, error, priceId) => [
        { type: "ShipmentPrice", id: priceId },
      ],
    }),
    printShipmentPriceInvoice: builder.mutation({
      query: (priceId) => ({
        url: `${SHIPMENT_BASE_URL}/prices/${priceId}/ebills/print-invoice`,
        method: "POST",
      }),
      invalidatesTags: (result, error, priceId) => [
        { type: "ShipmentPrice", id: priceId },
        { type: "ShipmentPrice", id: "LIST" },
      ],
    }),
    printShipmentStoredEBill: builder.mutation({
      query: ({ shipmentId, eBillId }) => ({
        url: `${SHIPMENT_BASE_URL}/${shipmentId}/ebills/${eBillId}/download`,
        method: "POST",
      }),
      invalidatesTags: (_result, _error, { shipmentId }) => [
        { type: "Shipment", id: shipmentId },
      ],
    }),
    printShipmentPriceCreditNote: builder.mutation({
      query: ({ priceId, creditNoteId }) => ({
        url: `${SHIPMENT_BASE_URL}/prices/${priceId}/ebills/print-credit-note/${creditNoteId}`,
        method: "POST",
      }),
      invalidatesTags: (result, error, { priceId }) => [
        { type: "ShipmentPrice", id: priceId },
        { type: "ShipmentPrice", id: "LIST" },
      ],
    }),
    // Mark a shipment as returning
    markShipmentReturning: builder.mutation({
      query: ({ shipmentId, returnReason }) => ({
        url: `${SHIPMENT_BASE_URL}/${shipmentId}/return`,
        method: "POST",
        body: { returnReason },
      }),
      invalidatesTags: (result, error, shipmentId) => [
        { type: "Shipment", id: shipmentId },
        { type: "ShipmentPrice", id: "LIST" },
        { type: "Shipment", id: "LIST" },
        { type: "Shipment", id: "DDL" },
      ],
    }),
    generateOTPCode: builder.mutation({
      query: (shipmentId) => ({
        url: `${SHIPMENT_BASE_URL}/${shipmentId}/generate-otp`,
        method: "POST",
      }),
      invalidatesTags: (result, error, shipmentId) => [
        { type: "Shipment", id: shipmentId },
      ],
    }),
    searchShipments: builder.query({
      query: ({ account, entity, query, vendorId, nonVendor, _t }) => ({
        url: `${SHIPMENT_BASE_URL}/search`,
        params: { account, entity, query, vendorId, nonVendor, _t },
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({ type: "Shipment", _id })),
            { type: "Shipment", id: "SEARCH" },
          ]
          : [{ type: "Shipment", id: "SEARCH" }],
    }),

    searchActiveShipments: builder.query({
      query: ({ account, entity, query }) => ({
        url: `${SHIPMENT_BASE_URL}/search-active`,
        params: { account, entity, query },
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({ type: "Shipment", _id })),
            { type: "Shipment", id: "SEARCH_ACTIVE" },
          ]
          : [{ type: "Shipment", id: "SEARCH_ACTIVE" }],
    }),

    searchShipmentWithBranch: builder.query({
      query: ({ account, entity, query, vendorProfileIds }) => ({
        url: `${SHIPMENT_BASE_URL}/search-with-branch`,
        params: { account, entity, query, vendorProfileIds },
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result.data.map(({ _id }) => ({ type: "Shipment", id: _id })),
            { type: "Shipment", id: "SEARCH_WITH_BRANCH" },
          ]
          : [{ type: "Shipment", id: "SEARCH_WITH_BRANCH" }],
    }),

    generateSecurityCode: builder.mutation({
      query: (shipmentId) => ({
        url: `${SHIPMENT_BASE_URL}/${shipmentId}/generate-security-code`,
        method: "POST",
      }),
      invalidatesTags: (result, error, shipmentId) => [
        { type: "Shipment", id: shipmentId },
      ],
    }),
    validateCode: builder.mutation({
      query: ({ shipmentId, code, codeType }) => ({
        url: `${SHIPMENT_BASE_URL}/${shipmentId}/validate-code`,
        method: "POST",
        body: { code, codeType },
      }),
    }),

    getShipmentBulkPrintDetails: builder.query({
      query: ({ shipmentIds }) => ({
        url: `${SHIPMENT_BASE_URL}/${shipmentIds}/bulk-print`,
        method: "POST",
        body: { shipmentIds },
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result.data.map(({ shipmentId }) => ({
              type: "Shipment",
              id: shipmentId,
            })),
            { type: "Shipment", id: "LIST" },
          ]
          : [{ type: "Shipment", id: "LIST" }],
    }),

    downloadShipments: builder.query({
      query: (params) => ({
        url: `${SHIPMENT_BASE_URL}/download`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result.data.map(({ shipmentId }) => ({
              type: "Shipment",
              id: shipmentId,
            })),
            { type: "Shipment", id: "LIST" },
          ]
          : [{ type: "Shipment", id: "LIST" }],
      keepUnusedDataFor: 5,
    }),

    getShipmentBySearchId: builder.query({
      query: ({ shipmentId, vendorId }) => {
        const params = new URLSearchParams();
        if (shipmentId) params.append("shipmentId", shipmentId);
        if (vendorId) params.append("vendorId", vendorId);
        return {
          url: `${SHIPMENT_BASE_URL}/searchForInvoice?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Shipment"],
    }),

    listShipmentTransitBranches: builder.query({
      query: ({ shipmentId }) => ({
        url: `${SHIPMENT_BASE_URL}/transit-branches?shipmentId=${shipmentId}`,
        method: "GET",
      }),
      providesTags: (_result, _error, { shipmentId }) => [
        { type: "Shipment", id: shipmentId },
      ],
    }),

    addShipmentTransitBranch: builder.mutation({
      query: (payLoad) => ({
        url: `${SHIPMENT_BASE_URL}/transit-branches`,
        method: "POST",
        body: payLoad,
      }),
      invalidatesTags: (_result, _error, { shipmentId }) => [
        { type: "Shipment", id: shipmentId },
        { type: "Shipment", id: "LIST" },
      ],
    }),

    updateShipmentTransitBranch: builder.mutation({
      query: (payLoad) => ({
        url: `${SHIPMENT_BASE_URL}/transit-branches/update`,
        method: "PATCH",
        body: payLoad,
      }),
      invalidatesTags: (_result, _error, { shipmentId }) => [
        { type: "Shipment", id: shipmentId },
        { type: "Shipment", id: "LIST" },
      ],
    }),

    searchShipmentWithPrimaryStatus: builder.query({
      query: ({ query }) => ({
        url: `${SHIPMENT_BASE_URL}/search-with-primary-status`,
        params: { query },
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result.data.map(({ _id }) => ({ type: "Shipment", id: _id })),
            { type: "Shipment", id: "SEARCH_WITH_PRIMARY_STATUS" },
          ]
          : [{ type: "Shipment", id: "SEARCH_WITH_PRIMARY_STATUS" }],
    }),

    updateShipmentPrimaryStatus: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `${SHIPMENT_BASE_URL}/${id}/primary-status`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Shipment", id },
        { type: "Shipment", id: "SEARCH_WITH_PRIMARY_STATUS" },
      ],
    }),
  }),
});

export const {
  useAddShipmentMutation,
  useAddShipmentAndCollectMutation,
  useAssignBulkRoutesMutation,
  useAssignBulkRoutesWarehouseMutation,
  useVendorShipmentAddMutation,
  useListShipmentQuery,
  useLazyListShipmentQuery,
  useLazyListShipmentStaleQuery,
  useLazyListShipmentStaleProvinceModeQuery,
  useLazyGetPendingShipmentsByBranchQuery,
  useLazyListShipmentForBulkCancelsQuery,
  useLazyGetDDLShipmentListQuery,
  useLazyGetDDLShipmentPendingListQuery,
  useLazyGetDDLShipmentListForCOCQuery,
  useLazyGetDDLShipmentListForCODQuery,
  useLazyGetDDLShipmentListForPrepaymentQuery,
  useGetShipmentQuery,
  useGetShipmentDetailQuery,
  useLazyGetShipmentDetailQuery,
  useUpdateShipmentMutation,
  useUpdateShipmentForVendorSideMutation,
  useAddShipmentCommentsMutation,
  useLazyGetShipmentLogsQuery,
  useUpdateShipmentCommentMutation,
  useLazyListShipmentCommentQuery,
  useAddShipmentReplyMutation,
  useUpdateShipmentReplyMutation,
  useAddShipmentDocumentByDShipmentIdMutation,
  useUpdateShipmentDocumentByShipmentIdMutation,
  useLazyListShipmentDocumentByShipmentIdQuery,
  useLazyListShipmentStopsQuery,
  useAddShipmentStopMutation,
  useUpdateShipmentStopsMutation,
  useCreateBulkShipmentsMutation,
  useAddShipmentRouteMutation,
  useListShipmentRoutesQuery,
  useLazyListShipmentRoutesQuery,
  useUpdateShipmentRouteMutation,
  useAddShipmentPriceMutation,
  useGenerateShipmentEBillMutation,
  useDownloadShipmentEBillMutation,
  useListShipmentPricesQuery,
  useLazyListShipmentPricesQuery,
  useUpdateShipmentPriceMutation,
  useGetShipmentPriceQuery,
  useLazyListPriceChangeLogsQuery,
  useGetShipmentPriceEBillsQuery,
  usePrintShipmentPriceInvoiceMutation,
  usePrintShipmentStoredEBillMutation,
  usePrintShipmentPriceCreditNoteMutation,
  useMarkShipmentReturningMutation,
  //otp
  useGenerateOTPCodeMutation,
  useGenerateSecurityCodeMutation,
  useValidateCodeMutation,
  useLazySearchShipmentsQuery,
  useLazySearchActiveShipmentsQuery,
  useSearchShipmentWithBranchQuery,
  useLazySearchShipmentWithBranchQuery,
  useLazyGetDDLBranchesWithPendingShipmentsQuery,
  useLazyGetShipmentBulkPrintDetailsQuery,

  useDownloadShipmentsQuery,
  useLazyDownloadShipmentsQuery,

  useLazyGetShipmentBySearchIdQuery,
  useAddShipmentTransitBranchMutation,
  useLazyListShipmentTransitBranchesQuery,
  useUpdateShipmentTransitBranchMutation,

  useLazySearchShipmentWithPrimaryStatusQuery,
  useUpdateShipmentPrimaryStatusMutation,
} = shipmentApi;
